import React from 'react';
import { CalendarDays, FileText, GraduationCap, MessageSquareText, Star, Users } from 'lucide-react';
import { PulsePanel, PulseEmpty } from './PulsePanel';
import { fmtTime, fmtClock, usePaged, PageDots } from './pulseUtils';

const DOTS = ['#922A8C', '#19B5C9', '#F5B400', '#F27BA6'];
const COLS = 'grid-cols-[120px_190px_minmax(0,1fr)_170px_120px]';

export const PulseSchedule = ({ rows, rotateSeconds }) => {
  const { slice, page, pages } = usePaged(rows, 3, (rotateSeconds || 8) * 1000);
  return (
    <PulsePanel icon={CalendarDays} title="Today's Schedule" pill="All Staff" testid="pulse-schedule" className="h-full">
      <div className="px-4 pt-2 flex-1 min-h-0 flex flex-col">
        <div className={`grid ${COLS} text-[16px] font-bold border-b border-[#ece6ee] py-1.5`}><span>Time</span><span>Participant</span><span>Type</span><span>Staff Member</span><span>Location</span></div>
        {rows.length === 0 ? <PulseEmpty text="No appointments scheduled today" testid="pulse-schedule-empty" /> : (
          <div key={page} className="flex-1 min-h-0 overflow-hidden pulse-fade-in">
            {slice.map((a, i) => (
              <div key={a.id} className={`grid ${COLS} items-center py-[5px] text-[18px] border-b border-[#f3eff4]`} data-testid="pulse-schedule-row">
                <span className="tabular-nums">{a.start_at ? fmtTime(a.start_at) : fmtClock(a.start_time)}</span>
                <span className="flex items-center gap-2 truncate"><span className="w-3 h-3 rounded-full shrink-0" style={{ background: DOTS[(page * 3 + i) % 4] }} />{a.participant}</span>
                <span className="truncate pr-2">{a.type}</span><span className="truncate pr-2">{a.staff}</span><span className="truncate">{a.location}</span>
              </div>
            ))}
          </div>
        )}
        <PageDots page={page} pages={pages} testid="pulse-schedule-pages" />
      </div>
    </PulsePanel>
  );
};

const ITEMS = [
  { key: 'courses_completed', label: 'Courses/Modules Completed Today', icon: GraduationCap, color: '#22B04B', bg: '#ecf8ee' },
  { key: 'documents_uploaded', label: 'Documents Uploaded Today', icon: FileText, color: '#2F9BEA', bg: '#e9f4fd' },
  { key: 'participant_messages', label: 'Participant Messages Today', icon: MessageSquareText, color: '#EF3A5D', bg: '#ffeef1' },
  { key: 'new_enrollments', label: 'New Enrollments Today', icon: Users, color: '#F5A400', bg: '#fff8e6' },
];

export const PulseHighlights = ({ h }) => (
  <PulsePanel icon={Star} title="Quick Highlights" testid="pulse-highlights" className="h-full">
    <div className="grid grid-cols-2 grid-rows-2 gap-3 p-4 flex-1">
      {ITEMS.map(({ key, label, icon: Icon, color, bg }) => (
        <div key={key} className="rounded-xl flex items-center gap-3 px-4 min-w-0" style={{ background: bg }} data-testid={`pulse-highlight-${key}`}>
          <Icon size={44} color={color} strokeWidth={2.2} />
          <div className="leading-tight"><div className="text-[40px] font-extrabold leading-none" style={{ color }} data-testid={`pulse-highlight-${key}-value`}>{h[key]}</div>
            <div className="text-[15px] font-semibold mt-1">{label}</div></div>
        </div>
      ))}
    </div>
  </PulsePanel>
);
